import React from "react";
import { Dropdown, Container, Form, Spinner } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { FiChevronDown } from "react-icons/fi";
import ReactTooltip from "react-tooltip";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import OutsideClickHandler from "react-outside-click-handler";
import { resolve, reject } from "q";
import RouteLeavingGuard from "../../../../Common/Components/RouteLeavingGuard";
import ForecastLock from "../../../../Common/Assets/Images/icons/forecast-lock.svg";
import { ReactPageLoader } from "../../../../Common/Components/ReactPageLoader";
import {
  IGetLaborDailyActivity,
  ISaveLaborDailyActivity,
  IGetLaborDailyActivityPermission,
  IGetExitsLaborHouseKeeping,
} from "../../../../Common/Contracts/ILaborDailyActivity";
import { LaborDailyActivity } from "../../../../Common/Services/LaborDailyActivity";
import { HidSelector } from "../../../../Common/Components/HidSelector";
import { LaborBudgetSetting } from "../../../../Common/Services/LaborBudgetSetting";
import { Utils } from "../../../../Common/Utilis";
import { API_ROOT } from "../../../../Common/Services/Api-config";
import {AES} from "crypto-js"
import { User } from "../../../../Common/Services/User";

// Defined Varaibles
let roomOccupiedID: number;
let arrivalID: number;
let departureID: number;
let stayOverID: number;
let occupiedIndex: number;
let arrivalIndex: number;
let departureIndex: number;
let stayOverIndex: number;
let routeLeavingGuard: any = null;
let alertHotelDetails: any = null;
let cheackDate: string = "";
let changeDates : Object = {};
export class DailyActivityIndex extends React.Component<any, any> {
  private childHID: any;
  constructor(props: any) {
    super(props);
    this.childHID = React.createRef();
    this.state = {
      hidValue: "",
      loaderTrue: false,
      calenderShow: false,
      calenderDate: {},
      calenderDateString: "",
      laborMgmtMinDate: {},
      calenderMaxDate: {},
      navigationDates: [],
      dailyActivityData: [],
      headerFullDates: [],
      headerDates: [],
      headerDays: [],
      lockDays: [],
      saveButtonSpinner: false,
      changeValue: false,
      permissionManageDAE: false,
      alertValidateManager: "",
      houseKeppingDate: "",
    };
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.beforeunload.bind(this));

    // Requirement : Getting Date and Setting day - 1 on page load, as DAE of current day is blocked
    let yesterdayDate: Date = new Date();
    yesterdayDate.setDate(yesterdayDate.getDate() - 1);

    let loadDate = yesterdayDate.getDate();
    let loadMonth = yesterdayDate.getMonth() + 1;
    let loadYear = yesterdayDate.getFullYear();
    let loadDateString = `${loadMonth}/${loadDate}/${loadYear}`;

    this.setState({
      calenderDateString: loadDateString,
      calenderDate: yesterdayDate,
    });
    
    if (this.state.hidValue !== "") {
      this.getDailyActivityPermission();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.beforeunload.bind(this));
  }

  beforeunload(e: { preventDefault: () => void; returnValue: boolean }) {
    if (
      this.state.changeValue &&
      routeLeavingGuard !== "routeLeavingGuardTrue"
    ) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  routeLeavingGuardConfirm = (childState: any) => {
    if (childState === true) {
      routeLeavingGuard = "routeLeavingGuardTrue";
    } else {
      routeLeavingGuard = null;
    }
  };

  getDailyActivityPermission = () => {
    let requestObject = {} as IGetLaborDailyActivityPermission;
    requestObject.hotelID = this.state.hidValue;
    LaborDailyActivity.GetDailyActivityPermission(requestObject)
      .then(async (result: any | null) => {
        if (result != null) {
          let storage = JSON.parse(localStorage.getItem("storage")!);
          let userName = storage === null ? 0 : (storage.userName as any);
           let mergeURL = result.urllink;
          
          let token = result.token;
          const serverTimeResponse = await User.GetServerTime();
          let currentTimeUTC = serverTimeResponse ? serverTimeResponse : null;

          if (!currentTimeUTC) {
              throw new Error("Failed to retrieve server time from API.");
          }
          if (mergeURL !== "") {
            window.open(
              mergeURL
              +
              "?logInUser=" +
              Utils.encryptString(`${userName}|${currentTimeUTC}`) +
              "&token=" +
              token +
              "&module=" +
              btoa("Accounting") +
              "&logInType=5" +
              "&Hid=" + btoa(this.state.hidValue) +
              "&Date=" + btoa(this.state.calenderDateString)
            );
          } else {
            this.getDailyActivityData("ehidDropdown");
          }
        } else {
          this.getDailyActivityData("ehidDropdown");
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error, ${err}`, {
          // // position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "dailiActivityIndex",
        });
        reject();
      });
  };

  selectHotelDropDown = (hotelDetails: any) => {
    if (this.state.changeValue) {
      alertHotelDetails = hotelDetails;
      this.isValidateModelPoupTab();
      this.setState({ alertValidateManager: "hidDropdown" });
    } else {
      alertHotelDetails = null;
      this.childHID?.current?.updateChildState(hotelDetails);
      this.setState({ hidValue: hotelDetails.hotelID }, () => {
        this.getDailyActivityPermission();

      });
    }
  };

  getDailyActivityData = (type: string) => {
    let request = {} as IGetLaborDailyActivity;
    request.hotelID = this.state.hidValue;
    request.date = this.state.calenderDateString;

    if (type === "ehidDropdown" || type === "calenderChange") {
      this.setState({ loaderTrue: true });
    }

    LaborDailyActivity.GetDailyActivity(request)
      .then(async (result: any) => {
        let dailyActivityData: any = [];
        let navigationDates: any = [];
        let lockDays: any = [];
        let headerFullDates: any = [];
        let headerDates: any = [];
        let headerDays: any = [];
        let laborMgmtMinDate: any = {};
        let calenderMaxDate: any = {};

        if (result != null && result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            // Getting Navigation Dates
            let displayDates: any = result[i].payPeriodDate.split("_");
            navigationDates = displayDates;

            // Generationg Calender Maximum Date
            let today = new Date();
            let yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            calenderMaxDate = new Date(yesterday.toJSON());

            // Destructing the row to get roomOccupied, arrival, departure and stayOver ID's
            // Arriving Order -- LaborManagementStartDate || RoomOccupliedId * ArrivalId * DepartureId * StayOverId
            let idVaraiblesDate: any = result[i].periodStartDate.split("||");

            // Getting LaborMgmtMinDate
            let periodStartDate = idVaraiblesDate[0];
            laborMgmtMinDate = new Date(periodStartDate);

            // Assigning roomOccupied, arrival, departure and stayOver ID's
            let idsArray: any = idVaraiblesDate[1].split("*");
            roomOccupiedID = Number(idsArray[0]);
            arrivalID = Number(idsArray[1]);
            departureID = Number(idsArray[2]);
            stayOverID = Number(idsArray[3]);

            // Checking Index of roomOccupied, arrival, departure and stayOver accoring to value in row
            if (Number(result[i].typeid) === roomOccupiedID) {
              occupiedIndex = i;
            }
            if (Number(result[i].typeid) === arrivalID) {
              arrivalIndex = i;
            }
            if (Number(result[i].typeid) === departureID) {
              departureIndex = i;
            }
            if (Number(result[i].typeid) === stayOverID) {
              stayOverIndex = i;
            }

            // Generating Table Row Object
            let tempRowObject: any = {};
            tempRowObject.id = i;
            tempRowObject.itemName = result[i].itemName;
            tempRowObject.typeid = Number(result[i].typeid);

            for (let j = 0; j <= 7; j++) {
              let dayValue = `day${j}`;
              let day_dailyActivityData = `day${j}_dailyActivityData`;
              let day_uniqueNo = `day${j}_uniqueNo`;
              let day_Date = `day${j}_Date`;

              let day = result[i][dayValue].split("||");
              tempRowObject[day_dailyActivityData] = day[3];
              tempRowObject[day_uniqueNo] = day[5];
              tempRowObject[day_Date] = day[0];
              if (day[2] === "Yes") {
                if (day[4] === "") {
                  if (day[3] === "") {
                    tempRowObject[dayValue] = "0";
                  } else {
                    tempRowObject[dayValue] = day[3];
                  }
                } else {
                  tempRowObject[dayValue] = day[4];
                }
              } else {
                tempRowObject[dayValue] = day[3];
              }

              if (tempRowObject[dayValue].includes(".")) {
                let value = tempRowObject[dayValue].split(".");
                tempRowObject[dayValue] = value[0];
              }

              if (j > 0) {
                if (day[2] === "No") {
                  lockDays.push(dayValue);
                }
                headerFullDates.push(day[0]);
                headerDates.push(day[0].substring(0, day[0].length - 3));
                headerDays.push(day[1]);
              }
            }
            // Pushing Object to an array for table Data
            dailyActivityData.push(tempRowObject);
          }

          // Removing multiple Entries and Blank Indexes from Arrays using Set
          const uniqueLockDays: any = new Set(lockDays);
          const arrayLockDays = [...uniqueLockDays];
          const uniquHeaderFullDates: any = new Set(headerFullDates);
          const arrayHeaderFullDates = [...uniquHeaderFullDates];
          const uniqueHeaderDates: any = new Set(headerDates);
          const arrayHeaderDates = [...uniqueHeaderDates];
          const uniqueHeaderDays: any = new Set(headerDays);
          const arrayHeaderDays = [...uniqueHeaderDays];

          this.setState({
            lockDays: arrayLockDays,
            headerFullDates: arrayHeaderFullDates,
            headerDates: arrayHeaderDates,
            headerDays: arrayHeaderDays,
            navigationDates,
            calenderMaxDate,
            laborMgmtMinDate,
            dailyActivityData,
            changeValue: false,
          });
        }
        this.setState({ loaderTrue: false });
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error: ${err}`, {
          // // position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "dailiActivityIndex",
        });
        this.setState({ loaderTrue: false });
        reject();
      });
  };

  calenderShow = () => {
    if (this.state.changeValue) {
      this.setState({ alertValidateManager: "calenderShow" });
      this.isValidateModelPoupTab();
    } else {
      this.setState({ calenderShow: true });
    }
  };

  calenderHide = () => {
    this.setState({ calenderShow: false });
  };

  calenderChange = (e: any) => {
    let calenderYear = e.getFullYear();
    let calenderDate = e.getDate();
    let calenderMonth = e.getMonth() + 1;
    let calenderDateString = `${calenderMonth}/${calenderDate}/${calenderYear}`;

    this.setState(
      { calenderDateString, calenderDate: e, calenderShow: false },
      () => {
        this.getDailyActivityData("calenderChange");
      }
    );
  };

  isValidateModelPoupTab() {
    confirmAlert({
      title: "Unsaved confirmation",
      message:
        "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.isChangeUnsaved(),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  isLabourHouseKepingMessage() {
    var day="day"
    if(this.state.houseKeppingDate.length > 10)
    {
      day="days"
    }
    confirmAlert({
      title: "Making this change will un-approve the following housekeeping "+day,
      message: `${this.state.houseKeppingDate} `,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.saveDailyActivity(),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }



  isChangeUnsaved = () => {
    if (this.state.alertValidateManager === "hidDropdown") {
      this.setState({ changeValue: false }, () => {
        if (alertHotelDetails !== null) {
          this.selectHotelDropDown(alertHotelDetails);
        }
      });
    } else if (this.state.alertValidateManager === "calenderShow") {
      this.handleDiscard();
      this.setState({ changeValue: false }, () => {
        this.calenderShow();
      });
    }
  };

  handleDiscard = () => {
    this.setState({ changeValue: false }, () => {
      this.getDailyActivityData("discard");
      cheackDate="";
      changeDates={};
    });
  };


  saveDailyActivity = () => {
    this.handleSave();
  };

  getLabourHousekeppingExits = () => {
    this.setState({
      saveButtonSpinner: true,
    });

    let finalDateString = "";
    for(let key in changeDates ){
      finalDateString += key +"||" +  changeDates[key] + ","
    }
    let requestObject = {} as IGetExitsLaborHouseKeeping;
    requestObject.hotelID = this.state.hidValue;
    requestObject.paystartdate = this.state.navigationDates[0];
    requestObject.payenddate = this.state.navigationDates[1];
    requestObject.date=finalDateString;
    LaborDailyActivity.getLabourHousekeppingExits(requestObject)
      .then(async (result: any) => {
        if (result != null) {
          
          let resultData = result;
          if (resultData.saveStatus === "Success") {

           

            this.setState({ houseKeppingDate: resultData.message,  saveButtonSpinner: false }, () => {
              this.isLabourHouseKepingMessage();
            });

          } if (resultData.saveStatus === "Fail") {
            this.handleSave();
            this.setState({ houseKeppingDate: "" }
            // , () => {
            //   this.handleSave();
            // }
            );

          }
        }
        // this.setState({
        //   saveButtonSpinner: false,
        //   changeValue: false,
        // });
        resolve();
      })
      .catch((err: any) => {
        this.setState({
          saveButtonSpinner: false
          // ,
          // changeValue: false,
        });
        Utils.toastError(`Server Error: ${err}`, {
          // position: toast.POSITION.BOTTOM_RIGHT,
          // containerId: "dailiActivityIndex",
        });
        reject();
      });
  }




  handleSave = () => {
    
    // Checking validations before save
    let data = [...this.state.dailyActivityData];
    let lockDays = [...this.state.lockDays];
    let validationFlag = false;
    let validationMessage = "";

    for (let i = 0; i < data.length; i++) {
      for (let j = 1; j <= 7; j++) {
        let day = `day${j}`;
        if (data[i][day] === "" && !lockDays.includes(day)) {
          let inputId = `tblDAE-row${i}-day${j}`;
          if (!$("#" + inputId).hasClass("red-border")) {
            $("#" + inputId).addClass("red-border");
          }

          validationFlag = true;
          validationMessage = `A Daily Activity Entry with blank values cannot be saved`;
        }
        if (
          Number(data[arrivalIndex][day]) > Number(data[occupiedIndex][day])
        ) {
          validationFlag = true;
          validationMessage = "Arrival can not be grater than Room Occupied";
        }
      }
    }
    if (validationFlag === true) {
      this.setState({
        saveButtonSpinner: false,
      });
      Utils.toastError(validationMessage, {
        // // position: toast.POSITION.BOTTOM_RIGHT,
        // // containerId: "dailiActivityIndex",
      });
      return;
    } else {
      this.setState({
        saveButtonSpinner: true,
      });

      let templateSaveData: any = [];
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let tenantID = storage === null ? 0 : (storage.tenantID as any);
      let loginUser = storage === null ? 0 : (storage.userName as any);
      for (let i = 0; i < data.length; i++) {
        for (let j = 1; j <= 7; j++) {
          
          let day = `day${j}`;
          let day_uniqueNo = `day${j}_uniqueNo`;
          let day_Date = `day${j}_Date`;
          let day_forecastData = `day${j}_forecastData`;

          let tempRowObject: any = {} as ISaveLaborDailyActivity;

          tempRowObject.hotelId = this.state.hidValue;
          tempRowObject.itemUniqueNo = data[i].typeid;
          tempRowObject.date = data[i][day_Date];
          tempRowObject.itemNo = "";
          tempRowObject.uniqueNo = 0;
          tempRowObject.itemName = data[i].itemName;
          tempRowObject.explanation = "";
          tempRowObject.userToken = "";
          tempRowObject.roomRevenueTotal = 0;
          tempRowObject.tenantID = tenantID;
          tempRowObject.roomId = data[i][day_uniqueNo];
          tempRowObject.loginUser = loginUser;
          if (lockDays.includes(day)) {
            if (data[i][day_forecastData] === "") {
              tempRowObject.total = "0";
            } else {
              tempRowObject.total = data[i][day_forecastData];
            }
          } else {
            tempRowObject.total = data[i][day];
          }
          tempRowObject.dateList=cheackDate;

          if (!lockDays.includes(day)) {
          templateSaveData.push(tempRowObject);
          }
        }
      }
      
      LaborDailyActivity.SaveDailyActivity(templateSaveData)
        .then(async (result: any) => {
          if (result != null) {
            let resultData = result.result as any;
            if (resultData.saveStatus === "Success") {
              cheackDate="";
              changeDates={};
              this.getDailyActivityData("handleSave");
              toast.success("Daily Activity saved successfully", {
                // // position: toast.POSITION.BOTTOM_RIGHT,
                // // containerId: "dailiActivityIndex",
              });

           
            // forecast budget calculation starts
            let request: any = {};
            let currentDate: any = null;
            currentDate = templateSaveData[0].date;
            request.hotelID = this.state.hidValue;
            request.layout = "7";
            request.date = currentDate;
            request.type = "ForeCast";
            LaborBudgetSetting.SaveBudgetCalculation(request)
            .then(async (result: any | null) => {})
            .catch((err: any) => {});
            // forecast budget calculation ends



            } else {
              Utils.toastError(`${resultData.saveStatus}`, {
                // // position: toast.POSITION.BOTTOM_RIGHT,
                // // containerId: "dailiActivityIndex",
              });
            }
          }
          this.setState({
            saveButtonSpinner: false,
            changeValue: false,
          });
          resolve();
        })
        .catch((err: any) => {
          this.setState({
            saveButtonSpinner: false,
            changeValue: false,
          });
          Utils.toastError(`Server Error: ${err}`, {
            // // position: toast.POSITION.BOTTOM_RIGHT,
            // // containerId: "dailiActivityIndex",
          });
          reject();
        });
    }
  };

  onFocusInput = (e: any, rowIndex: any) => {
    let rowIdx = rowIndex + 1;
    $("#tblDAE tbody tr:nth-child(" + rowIdx + ")").addClass("focus-row");
  };

  onChangeInput = (e: any, row: any, rowIndex: any, dayNo: any) => {
    let value = e.target.value;
    let cursorIndex = e.target.selectionStart;
    let newTableData = JSON.parse(JSON.stringify(this.state.dailyActivityData));

    let inputId: string = `tblDAE-row${rowIndex}-${dayNo}`;

    // Numeric Only Validaiton
    if (/^\d+$/.test(value) === false) {
      value = value.replace(/[^\d]/g, "");
    }

    // Max length validation
    if (value.length > 8) {
      let a = value.replace(/[^\d]/g, "");
      value = a.substring(0, value.length - 1);
    }



    if (value !== "") {
      let findDate: string = `${dayNo}_Date`;
      let dateVale = newTableData[rowIndex][findDate];      
      if (cheackDate.indexOf(dateVale) === -1) {
        if(row.typeid===1)
        {
          changeDates[dateVale] = value;
          cheackDate += dateVale +",";
        }else{
         // changeDates["01/01/2001"] = value;
        }
      } else{
        if(row.typeid===1)
        {
          changeDates[dateVale] = value;
        }else{
         // changeDates["01/01/2001"] = value;
        }
      }
      
    }

    // Updating Table Data
    newTableData[rowIndex][dayNo] = value;

    this.setState(
      {
        dailyActivityData: newTableData,
        changeValue: true,
      },
      () => {
        // Addign Cursor to correct index
        $("#" + inputId)
          .focus()
          .prop("selectionEnd", cursorIndex);
      }
    );
  };

  onBlurInput = (e: any, row: any, rowIndex: any, dayNo: any) => {
    // Removal of class focus
    let rowIdx = rowIndex + 1;
    if ($("#tblDAE tbody tr:nth-child(" + rowIdx + ")").hasClass("focus-row")) {
      $("#tblDAE tbody tr:nth-child(" + rowIdx + ")").removeClass("focus-row");
    }

    let value = e.target.value;

    // To remove starting 0 from feild
    if (value !== "") {
      value = Number(value);
      value = value.toString();
    }

    let newTableData = JSON.parse(JSON.stringify(this.state.dailyActivityData));

    let inputId: string = `tblDAE-row${rowIndex}-${dayNo}`;

    // Updating Table Data
    // Update input value
    newTableData[rowIndex][dayNo] = value;

    let addOccuGrtArriVlidaion: boolean = false; // Adding redClass
    let removeOccuGrtArriVlidaion: boolean = false; // Maintiang and Removing Red Class

    // Calculate the Departure and Stay Over only if input is Room Occupied or Arrival
    if (row.typeid === roomOccupiedID || row.typeid === arrivalID) {
      // check validation 1 - Arrival can't be grater than Room Occupied
      if (
        Number(newTableData[arrivalIndex][dayNo]) >
        Number(newTableData[occupiedIndex][dayNo])
      ) {
        addOccuGrtArriVlidaion = true;
        Utils.toastError("Arrival can not be grater than Room Occupied", {
          // // position: toast.POSITION.BOTTOM_RIGHT,
          // // containerId: "dailiActivityIndex",
        });
      } else {
        removeOccuGrtArriVlidaion = true;
        // Generating Current day and previous day
        let currentDayString: string = dayNo.substring(
          dayNo.length - 1,
          dayNo.length
        );
        let currentDayNumber: number = Number(currentDayString);
        let previousDayNumber: number = currentDayNumber - 1;
        let prevDay: string = `day${previousDayNumber}`;
        let nextDayNumber: number = currentDayNumber + 1;
        let nextDay: string = `day${nextDayNumber}`;

        // calculation - Departure[day] = RoomOccupied[day-1] + Arrival[day] - RoomOccupied[day]
        // calculation - Stay Over[day] = RoomOccupied[day-1] - Departure[day]

        newTableData[departureIndex][dayNo] = (
          Number(newTableData[occupiedIndex][prevDay]) +
          Number(newTableData[arrivalIndex][dayNo]) -
          Number(newTableData[occupiedIndex][dayNo])
        ).toString();
        newTableData[stayOverIndex][dayNo] = (
          Number(newTableData[occupiedIndex][prevDay]) -
          Number(newTableData[departureIndex][dayNo])
        ).toString();

        // Updating next days values only if it's not the last day of pay period and its not locked
        if (currentDayNumber < 7 && !this.state.lockDays.includes(nextDay)) {
          newTableData[departureIndex][nextDay] = (
            Number(newTableData[occupiedIndex][dayNo]) +
            Number(newTableData[arrivalIndex][nextDay]) -
            Number(newTableData[occupiedIndex][nextDay])
          ).toString();
          newTableData[stayOverIndex][nextDay] = (
            Number(newTableData[occupiedIndex][dayNo]) -
            Number(newTableData[departureIndex][nextDay])
          ).toString();
        }
      }
    }

    this.setState(
      {
        dailyActivityData: newTableData,
      },
      () => {
        // Adding and Removing Valdation Classes on blank input
        if (value === "") {
          $("#" + inputId).addClass("red-border");
        } else if ($("#" + inputId).hasClass("red-border")) {
          $("#" + inputId).removeClass("red-border");
        } else {
        }

        // Adding Valdation Classes on Room Occupied greater than arrival entry
        if (
          addOccuGrtArriVlidaion &&
          !$("#" + inputId).hasClass("red-border")
        ) {
          $("#" + inputId).addClass("red-border");
        }

        // Remvoing Valdation Classes on Room Occupied greater than arrival entry
        if (removeOccuGrtArriVlidaion) {
          // Getting indexes of both row in table
          let dailyActivityData = [...this.state.dailyActivityData];
          let occupiedInputId: string = "";
          let arrivalInputId: string = "";

          for (let i = 0; i < dailyActivityData.length; i++) {
            if (dailyActivityData[i].typeid === roomOccupiedID) {
              occupiedInputId = `tblDAE-row${i}-${dayNo}`;
              break;
            }
          }

          for (let i = 0; i < dailyActivityData.length; i++) {
            if (dailyActivityData[i].typeid === arrivalID) {
              arrivalInputId = `tblDAE-row${i}-${dayNo}`;
              break;
            }
          }

          if (
            occupiedInputId !== "" &&
            $("#" + occupiedInputId).hasClass("red-border")
          ) {
            $("#" + occupiedInputId).removeClass("red-border");
          }

          if (
            arrivalInputId !== "" &&
            $("#" + arrivalInputId).hasClass("red-border")
          ) {
            $("#" + arrivalInputId).removeClass("red-border");
          }
        }
      }
    );
  };

  headerFormatter = (column: any, colIndex: any, row: any) => {
    let forecastLockDisplay = false;
    let lockDays = this.state.lockDays;
    let headerDates = this.state.headerDates;
    let headerDays = this.state.headerDays;
    if (lockDays.includes(column.dataField)) {
      forecastLockDisplay = true;
    }
    const tooltipMessage =
      "The Daily Activity cannot be entered for current and future days.";
    return (
      <div className="column-header">
        <div className="header-data">
          {forecastLockDisplay && (
            <span className="forecast-lock" data-tip={tooltipMessage}>
              <ReactTooltip
                effect="solid"
                event="mouseover mouseenter"
                eventOff="mouseleave mouseout scroll mousewheel blur"
                place="bottom"
                multiline={true}
              />
              <img src={ForecastLock} alt="ForecastLock" />
            </span>
          )}

          <span className="header-day">{headerDays[colIndex - 1]}</span>
        </div>
        <p className="header-date">{headerDates[colIndex - 1]}</p>
      </div>
    );
  };

  inputformatter = (cell: any, row: any, rowIndex: any, dayNo: any) => {
    // Div for non editable input and Form.Control for editable input
    if (
      this.state.lockDays.includes(dayNo) ||
      // !this.state.permissionManageDAE ||
      row.typeid === stayOverID ||
      row.typeid === departureID
    ) {
      // Conditional Class Name
      let condClass = "daeBlock";
      if (this.state.lockDays.includes(dayNo)) {
        condClass = `${condClass} lockDay`;
      }

      if (row.typeid === stayOverID || row.typeid === departureID) {
        condClass = `${condClass} boxed`;
      }
      return <div className={condClass}>{cell}</div>;
    } else {
      // Generating unique id for additonal validation classes
      const inputId: string = `tblDAE-row${rowIndex}-${dayNo}`;

      return (
        <div className="forecast-name">
          <Form.Group className="daily-activity-input">
            <Form.Control
              id={inputId}
              value={row[dayNo]}
              onFocus={(e: any) => {
                this.onFocusInput(e, rowIndex);
              }}
              onChange={(e: any) => {
                this.onChangeInput(e, row, rowIndex, dayNo);
              }}
              onBlur={(e: any) => {
                this.onBlurInput(e, row, rowIndex, dayNo);
              }}
            />
          </Form.Group>
        </div>
      );
    }
  };

// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<AUTO GENERATED BY CONFLICT EXTENSION<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< TestingUI
// ====================================AUTO GENERATED BY CONFLICT EXTENSION====================================

  // isLabourHouseKepingMessage() {
  //   var day="day"
  //   if(this.state.houseKeppingDate.length > 10)
  //   {
  //     day="days"
  //   }
  //   confirmAlert({
  //     title: "Making this change will un-approve the following housekeeping "+day,
  //     message: `${this.state.houseKeppingDate} `,
  //     buttons: [
  //       {
  //         label: "Yes",
  //         onClick: () => this.saveDailyActivity(),
  //       },
  //       {
  //         label: "No",
  //         onClick: () => reject(),
  //       },
  //     ],
  //     closeOnEscape: false,
  //     closeOnClickOutside: false,
  //   });
  // }

  // getLabourHousekeppingExits = () => {
  //   this.setState({
  //     saveButtonSpinner: true,
  //   });
  //   let requestObject = {} as IGetExitsLaborHouseKeeping;
  //   requestObject.hotelID = this.state.hidValue;
  //   requestObject.paystartdate = this.state.navigationDates[0];
  //   requestObject.payenddate = this.state.navigationDates[1];
  //   requestObject.date=cheackDate;
  //   LaborDailyActivity.getLabourHousekeppingExits(requestObject)
  //     .then(async (result: any) => {
  //       if (result != null) {
  //         ;
  //         let resultData = result;
  //         if (resultData.saveStatus === "Success") {

           

  //           this.setState({ houseKeppingDate: resultData.message,  saveButtonSpinner: false }, () => {
  //             this.isLabourHouseKepingMessage();
  //           });

  //         } if (resultData.saveStatus === "Fail") {
  //           this.handleSave();
  //           this.setState({ houseKeppingDate: "" }
  //           // , () => {
  //           //   this.handleSave();
  //           // }
  //           );

  //         }
  //       }
  //       // this.setState({
  //       //   saveButtonSpinner: false,
  //       //   changeValue: false,
  //       // });
  //       resolve();
  //     })
  //     .catch((err: any) => {
  //       this.setState({
  //         saveButtonSpinner: false
  //         // ,
  //         // changeValue: false,
  //       });
  //       Utils.toastError(`Server Error: ${err}`, {
  //         // // position: toast.POSITION.BOTTOM_RIGHT,
  //         // // containerId: "dailiActivityIndex",
  //       });
  //       reject();
  //     });
  // }

 
  render() {
    const columns = [
      {
        dataField: "itemName",
        text: "",
        editable: false,
        formatter: (cell: any, row: any, rowIndex: any) => (
          <div className="item-name">
            <EllipsisWithTooltip placement="bottom">
              <span>{row.itemName}</span>
            </EllipsisWithTooltip>
          </div>
        ),
      },
      {
        dataField: "day1",
        text: "",
        headerFormatter: this.headerFormatter,
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.inputformatter(cell, row, rowIndex, "day1"),
      },
      {
        dataField: "day2",
        text: "",
        headerFormatter: this.headerFormatter,
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.inputformatter(cell, row, rowIndex, "day2"),
      },
      {
        dataField: "day3",
        text: "",
        headerFormatter: this.headerFormatter,
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.inputformatter(cell, row, rowIndex, "day3"),
      },
      {
        dataField: "day4",
        text: "",
        headerFormatter: this.headerFormatter,
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.inputformatter(cell, row, rowIndex, "day4"),
      },
      {
        dataField: "day5",
        text: "",
        headerFormatter: this.headerFormatter,
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.inputformatter(cell, row, rowIndex, "day5"),
      },
      {
        dataField: "day6",
        text: "",
        headerFormatter: this.headerFormatter,
        formatter: (cell: any, row: any, rowIndex: any) =>
          this.inputformatter(cell, row, rowIndex, "day6"),
      },
      {
        dataField: "day7",
        text: "",
        headerFormatter: this.headerFormatter,

        formatter: (cell: any, row: any, rowIndex: any) =>
          this.inputformatter(cell, row, rowIndex, "day7"),
      },
    ];

    return (
      <>
        <RouteLeavingGuard
          when={this.state.changeValue}
          routeLeavingGuardConfirm={this.routeLeavingGuardConfirm}
          shouldBlockNavigation={(location: { pathname: any }) => {
            if (this.state.changeValue) {
              if (location.pathname) {
                return true;
              }
            }
            return false;
          }}
        />
         {/* <ToastContainer
          enableMultiContainer
          autoClose={3000}
          containerId={"dailiActivityIndex"}
        /> */} 

        <div className="forecastModule dailyActivity">
          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex">
              <HidSelector
                onClickEvent={this.selectHotelDropDown}
                ref={this.childHID}
                alertComponent={this.state.changeValue}
              />

              <div className="mr-auto">Daily Activity Entry</div>

              {this.state.hidValue !== "" && (
                <div className="header-popout">
                  <Dropdown className="more-action" alignRight>
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more"
                      id="dropdown-more"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                    </Dropdown.Toggle>
                  </Dropdown>
                </div>
              )}
            </div>

            {this.state.loaderTrue ? (
              <ReactPageLoader useas={"dailyActivityMain"} />
            ) : (
              this.state.dailyActivityData.length > 0 && (
                <div className="main-Page">
                  <div className="navigation-menus d-flex">
                    <div className="calender-container ml-0">
                      <div
                        className={
                          this.state.calenderShow
                            ? "calender-display open"
                            : "calender-display"
                        }
                        onClick={this.calenderShow}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
                          <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
                        </svg>
                        <span className="prev-Date">
                          {this.state.navigationDates[0]}
                        </span>
                        <span className="seperator"> - </span>
                        <span className="next-Date">
                          {this.state.navigationDates[1]}
                        </span>
                        <span className="chevron-down">
                          <FiChevronDown />
                        </span>
                      </div>
                      {this.state.calenderShow && (
                        <div className="calender">
                          <OutsideClickHandler
                            onOutsideClick={this.calenderHide}
                          >
                            <Calendar
                              calendarType={"US"}
                              onChange={this.calenderChange}
                              value={this.state.calenderSelectDate}
                              minDate={this.state.laborMgmtMinDate}
                              maxDate={this.state.calenderMaxDate}
                            />
                          </OutsideClickHandler>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="forecast-table">
                    <BootstrapTable
                      id="tblDAE"
                      keyField="id"
                      data={this.state.dailyActivityData}
                      columns={columns}
                      hover
                    />
                  </div>
                  {this.state.changeValue && (
                    // this.state.permissionManageDAE &&
                    <div className="fixed-action relative">
                      <div className="d-flex align-content-center flex-wrap">
                        <div className="mr-auto message">
                          <span>You have unsaved changes</span>
                        </div>
                        <button
                          type="button"
                          className="btn btn-primary btn-discard"
                          onClick={() => this.handleDiscard()}
                        >
                          Discard
                        </button>
                        <button
                          type="button"
                          className={
                            this.state.saveButtonSpinner
                              ? "btn btn-primary p-none"
                              : "btn btn-primary"
                          }
                          onClick={() => this.getLabourHousekeppingExits()}
                        >
                          {this.state.saveButtonSpinner && (
                            <Spinner
                              className="mr-2"
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          )}
                          Save Changes
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )
            )}
          </Container>
        </div>
      </>
    );
  }
}